import { FC } from 'react'

import { HeatingValueRoot } from './HeatingAndHotWater.style'

interface IProps {
  value: string | undefined
}
const HeatingValueField: FC<IProps> = ({ value = '' }) => {
  return <HeatingValueRoot>{value || 'N/A'}</HeatingValueRoot>
}

export default HeatingValueField
